import { defineNuxtPlugin } from '#app';
import * as bootstrap from 'bootstrap';

export default defineNuxtPlugin(() => {
    if (process.client) {
        window.bootstrap = bootstrap;
        console.log('Bootstrap JS loaded!', window.bootstrap);
    }
});
